import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Pages/Home/Index';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './Pages/ScrollToTop';
import Layout from './Layout/Layout';
import VRTour from './Pages/VRTour';
import Click from './Pages/Click/Click';
import ClickFloor from './Pages/Click/Floors/Clickable-Floors/ClickFloor';
import ClickFloor34 from './Pages/Click/Floors/Clickable-Floors/ClickFloor34';
import Visuals from './Pages/Visuals/Index'

import FirstFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor1/Floor1'
import SecondFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor2/Floor2'
import ThirdFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor3/Floor3'
import FourthFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor4/Floor4'
import FifthFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor5/Floor5'
import SixthFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor6/Floor6'
import SeventhFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor7/Floor7'
import EighthFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor8/Floor8'
import NinethFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor9/Floor9'
import TenthFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor10/Floor10'
import EleventhFloor from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/Floor11/Floor11'
import SameFloors34 from './Pages/Click/Floors/Clickable-Floors/Direct-Floors/SameFloors34/SameFloors34'


import Flipbook from './Pages/Flipbook/Index'
import Flipbook34 from './Pages/Flipbook/Index34'
import NavigateFloor from './Pages/Click/NavigateFloor';
import ExteriorVR from './Pages/ExteriorVR';
import Contact from './Pages/Contact/Index'
import About from './Pages/About/Index'
import Videos from './Pages/Videos/Index'
import Projects from './Pages/Projects/Index'
import Services from './Pages/Services/Index'
import Animation from './Pages/Animation/Index'


//all vrs
import Vr1n1 from './Pages/VRs/1/Vr1Level1'
import Vr1n2 from './Pages/VRs/1/Vr1Level2'
import Vr1n3 from './Pages/VRs/1/Vr1Level3'
import Vr1n4 from './Pages/VRs/1/Vr1Level4'

import Vr2 from './Pages/VRs/Vr2'

import Vr3n1 from './Pages/VRs/3/Vr3Level1'
import Vr3n2 from './Pages/VRs/3/Vr3Level2'
import Vr3n3 from './Pages/VRs/3/Vr3Level3'

import Vr4 from './Pages/VRs/Vr4'

import Vr5n1 from './Pages/VRs/5/Vr5Level1'
import Vr5n2 from './Pages/VRs/5/Vr5Level2'
import Vr5n3 from './Pages/VRs/5/Vr5Level3'

import Vr6 from './Pages/VRs/Vr6'
import Vr7 from './Pages/VRs/Vr7'

import Vr8n1 from './Pages/VRs/8/Vr8Level1'
import Vr8n2 from './Pages/VRs/8/Vr8Level2'

import Vr9n1 from './Pages/VRs/9/Vr9Level1'
import Vr9n2 from './Pages/VRs/9/Vr9Level2'
import Vr9n3 from './Pages/VRs/9/Vr9Level3'

import Vr10n1 from './Pages/VRs/10/Vr10Level1'
import Vr10n2 from './Pages/VRs/10/Vr10Level2'

import Vr11 from './Pages/VRs/Vr11'

import Vr12n2 from './Pages/VRs/12/Vr12Level2'
import Vr12n3 from './Pages/VRs/12/Vr12Level3'

import Vr13 from './Pages/VRs/Vr13'
import Vr14 from './Pages/VRs/Vr14'
import Vr15 from './Pages/VRs/Vr15'
import Vr16 from './Pages/VRs/Vr16'
import Vr17 from './Pages/VRs/Vr17'
import Vr18 from './Pages/VRs/Vr18'
import Vr19 from './Pages/VRs/Vr19'

import Vr19nn1 from './Pages/VRs/19n/Vr19nLevel1'
import Vr19nn2 from './Pages/VRs/19n/Vr19nLevel2'
import Vr19nn3 from './Pages/VRs/19n/Vr19nLevel3'
import Vr19nn4 from './Pages/VRs/19n/Vr19nLevel4'

import Vr20n1 from './Pages/VRs/20/Vr20Level1'
import Vr20n2 from './Pages/VRs/20/Vr20Level2'
import Vr20n3 from './Pages/VRs/20/Vr20Level3'

import { BrowserRouter, Route, Routes } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>
        {/* Routes that should have the layout */}
        <Route element={<Layout />}>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/contact' element={<Contact />} />
          <Route exact path='/about' element={<About />} />
          <Route exact path='/videos' element={<Videos />} />
          <Route exact path='/projects' element={<Projects />} />
          <Route exact path='/click' element={<Click />} />
          <Route exact path='/click-floor' element={<ClickFloor />} />
          <Route exact path='/click-floor-34' element={<ClickFloor34 />} />
          <Route exact path='/vizualizimet' element={<Visuals />} />
          {/* floors */}
          <Route exact path='/first-floor' element={<FirstFloor />} />
          <Route exact path='/second-floor' element={<SecondFloor />} />
          <Route exact path='/third-floor' element={<ThirdFloor />} />
          <Route exact path='/fourth-floor' element={<FourthFloor />} />
          <Route exact path='/fifth-floor' element={<FifthFloor />} />
          <Route exact path='/sixth-floor' element={<SixthFloor />} />
          <Route exact path='/seventh-floor' element={<SeventhFloor />} />
          <Route exact path='/eighth-floor' element={<EighthFloor />} />
          <Route exact path='/nineth-floor' element={<NinethFloor />} />
          <Route exact path='/tenth-floor' element={<TenthFloor />} />
          <Route exact path='/eleventh-floor' element={<EleventhFloor />} />
          <Route exact path='/same-floors-34' element={<SameFloors34 />} />
          <Route exact path='/flipbook' element={<Flipbook />} />
          <Route exact path='/flipbook34' element={<Flipbook34 />} />
          <Route exact path='/navigate-floor' element={<NavigateFloor />} />
          <Route exact path='/services' element={<Services />} />
          <Route exact path='/animation' element={<Animation />} />
        </Route>

        {/* Routes that should NOT have the layout */}
        <Route exact path='/exterior-vr' element={<ExteriorVR />} />
        <Route exact path='/vr' element={<VRTour />} />
        <Route exact path='vr-1-1'element={<Vr1n1/>}/>
        <Route exact path='vr-1-2'element={<Vr1n2/>}/>
        <Route exact path='vr-1-3'element={<Vr1n3/>}/>
        <Route exact path='vr-1-4'element={<Vr1n4/>}/>

        <Route exact path='vr-3-1'element={<Vr3n1/>}/>
        <Route exact path='vr-3-2'element={<Vr3n2/>}/>
        <Route exact path='vr-3-3'element={<Vr3n3/>}/>


        <Route exact path='vr-2'element={<Vr2/>}/>
        <Route exact path='vr-4'element={<Vr4/>}/>
        
        <Route exact path='vr-5-1'element={<Vr5n1/>}/>
        <Route exact path='vr-5-2'element={<Vr5n2/>}/>
        <Route exact path='vr-5-3'element={<Vr5n3/>}/>


        <Route exact path='vr-6'element={<Vr6/>}/>
        <Route exact path='vr-7'element={<Vr7/>}/>

        <Route exact path='vr-8-1'element={<Vr8n1/>}/>
        <Route exact path='vr-8-2'element={<Vr8n2/>}/>

        <Route exact path='vr-9-1'element={<Vr9n1/>}/>
        <Route exact path='vr-9-2'element={<Vr9n2/>}/>
        <Route exact path='vr-9-3'element={<Vr9n3/>}/>

        <Route exact path='vr-10-1'element={<Vr10n1/>}/>
        <Route exact path='vr-10-2'element={<Vr10n2/>}/>


        <Route exact path='vr-11'element={<Vr11/>}/>
        
        <Route exact path='vr-12-2'element={<Vr12n2/>}/>
        <Route exact path='vr-12-3'element={<Vr12n3/>}/>


        <Route exact path='vr-13'element={<Vr13/>}/>
        <Route exact path='vr-14'element={<Vr14/>}/>
        <Route exact path='vr-15'element={<Vr15/>}/>
        <Route exact path='vr-16'element={<Vr16/>}/>
        <Route exact path='vr-17'element={<Vr17/>}/>
        <Route exact path='vr-18'element={<Vr18/>}/>
        <Route exact path='vr-19'element={<Vr19/>}/>

        <Route exact path='vr-19n-1'element={<Vr19nn1/>}/>
        <Route exact path='vr-19n-2'element={<Vr19nn2/>}/>
        <Route exact path='vr-19n-3'element={<Vr19nn3/>}/>
        <Route exact path='vr-19n-4'element={<Vr19nn4/>}/>

        <Route exact path='vr-20-1'element={<Vr20n1/>}/>
        <Route exact path='vr-20-2'element={<Vr20n2/>}/>
        <Route exact path='vr-20-3'element={<Vr20n3/>}/>
        
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
